import type { Chart, ChartData, ChartOptions, Plugin } from 'chart.js';
import { type MutableRefObject, type ReactNode, type RefObject, useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

import { DEFAULT_BAR_CHART_OPTIONS } from '../lib/default-chart-options';
import { mergeChartConfig } from '../lib/merge-chart-config';

export type BaseBarChartProps = {
  chartRef?: RefObject<Chart<'bar'>>;
  data: ChartData<'bar'>;
  options?: ChartOptions<'bar'>;
  plugins?: Plugin<'bar'>[];
  children?: ReactNode;
};

export const BaseBarChart = ({
  chartRef,
  data,
  options,
  plugins,
  children,
}: BaseBarChartProps) => {
  const mergedOptions = useMemo(
    () => mergeChartConfig(DEFAULT_BAR_CHART_OPTIONS, options),
    [options],
  );

  return (
    <>
      <Bar
        ref={chartRef as MutableRefObject<Chart<'bar'> | undefined | null>}
        data={data}
        options={mergedOptions}
        plugins={plugins ?? []}
      />
      {children}
    </>
  );
};
